const past2 = '2022-11-30T12:13:00+01:00';
const past = '2022-12-04T12:13:00+01:00';
const future = '2022-12-07T12:11:00+01:00';
const future2 = '2022-12-11T12:13:00+01:00';

import { InterfacePearlChainLeg } from './paf-result-pearl-chain.custom';

export const futureLeg: InterfacePearlChainLeg = {
  arrival: future2,
  cancelled: false,
  departure: future,
};

export const cancelledLeg: InterfacePearlChainLeg = {
  arrival: future2,
  cancelled: true,
  departure: future,
};

export const cancelledPastLeg: InterfacePearlChainLeg = {
  arrival: past,
  cancelled: true,
  departure: past2,
};

export const progressLeg: InterfacePearlChainLeg = {
  arrival: future,
  cancelled: false,
  departure: past,
};

export const pastLeg: InterfacePearlChainLeg = {
  arrival: past,
  cancelled: false,
  departure: past2,
};

export const redirectedOnDepartureLeg: InterfacePearlChainLeg = {
  arrival: future2,
  cancelled: false,
  departure: future,
  stopPoints: [
    {
      stopStatus: 'NOT_SERVICED',
    },
    {
      stopStatus: 'PLANNED',
    },
  ],
};

export const redirectedOnArrivalLeg: InterfacePearlChainLeg = {
  arrival: future2,
  cancelled: false,
  departure: future,
  stopPoints: [
    {
      stopStatus: 'PLANNED',
    },
    {
      stopStatus: 'NOT_SERVICED',
    },
  ],
};
